// @flow
import client from '../../client'

// Types
import type { TCompany } from './register'

export type { TCompany as Company }

// API Endpoints
export const COMPANY_AUTOCOMPLETE_ENDPOINT =
  '/travel_agent/company/autocomplete/'

/**
 * Get a list of companies
 * @param {Object} [data] Query data
 * @param {string} [data.query] Company query
 * @returns {Promise | Error} A resolved Promise with companies or Rejected with an Error
 */
export const getCompanies = (data?: { query: string }): Promise<TCompany[]> =>
  client.get(COMPANY_AUTOCOMPLETE_ENDPOINT, { query: data })

export default getCompanies
